/**
 *
 * THIS SCRIPT IS DEPRECATED. WE ARE NO LONGER USING MIXPANEL
 *
 * BI Event tracking autohandler.
 *
 * Usage:
 *
 *  data-sw-tracking="<event name>"
 *  data-sw-tracking-<property>="<value>"
 *  data-sw-tracking-services="event-tracking mixpanel ga"
 */

var $ = require('js/sw-jquery/sw-jquery');
var swEventTracking = require('js/lib/sw-event-tracking');
var _ = require('underscore');

$(function() {
  $('body').on('click', '[data-sw-tracking]', function() {
    var $el = $(this);
    var elData = $el.data();

    if (_.contains(['change', 'change-dropdown', 'open-dropdown'], elData.swTrackingTrigger )) {
      return;
    }

    swEventTracking.handleTracking($el.swDataParams('swTracking'));
  });

  /**
   * Track when a dropdown is opened. Put these attrs on a div wrapping the Selectric select:
   *
   * <div data-sw-tracking="clicked" data-sw-tracking-trigger="open-dropdown">
   *     <select>{{{ options }}}</select>
   * </div>
   */
  $('body').on('click', '[data-sw-tracking][data-sw-tracking-trigger="open-dropdown"]', function() {
    var $el = $(this);
    if ($el.has('.sw-dropdown-open').length) {
      swEventTracking.handleTracking($el.swDataParams('swTracking'));
    }
  });

  $('body').on('change', '[data-sw-tracking][data-sw-tracking-trigger="change"]', function() {
    swEventTracking.handleTracking($(this).swDataParams('swTracking'));
  });

  /**
   * Track when dropdown option is changed. Put these attrs on the select, then also add tracking
   * attrs to the options:
   *
   * <select name="{{{ name }}}"
   *   data-sw-tracking="clicked"
   *   data-sw-tracking-trigger="change-dropdown"
   *   data-sw-tracking-services="mixpanel">
   *     <option value="{{ value }}"
   *      data-sw-tracking="clicked"
   *      data-sw-tracking-link-type="material-dropdown-option"
   *      data-sw-tracking-target-section="{{ targetSection }}"
   *      data-sw-tracking-services="mixpanel">{{ label }}</option>
   * </select>
   */
  $('body').on('change', '[data-sw-tracking][data-sw-tracking-trigger="change-dropdown"]', function() {
    swEventTracking.handleTracking($(this).find(':selected').swDataParams('swTracking'));
  });
});
